export default __webpack_public_path__ + "img/reward_1-1-fe34350e.png";